import { lang } from '@umu/ukit-lang';
import { IRadioItem, IPlainData } from '@umu/umu-types';
/**
 * @description 举报内容原因
 */
export const REPORT_REASON_FOR_CONTENT = {
    1: lang('不受欢迎的商业内容或垃圾内容'),
    2: lang('色情或露骨内容'),
    3: lang('虐待儿童'),
    4: lang('仇恨言论或过于写实的暴力内容'),
    5: lang('骚扰或欺凌'),
};

/**
 * @description 举报用户原因
 */
export const REPORT_REASON_FOR_USER = {
    1: lang('骚扰和网络欺凌'),
    2: lang('隐私权'),
    3: lang('冒充'),
    4: lang('暴力威胁'),
    5: lang('危害儿童'),
    6: lang('对受保护的群体发表仇恨言论'),
    7: lang('垃圾内容和欺诈行为'),
};

export function transformReasonList(data: IPlainData) {
    const list: IRadioItem[] = [];
    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            const label = data[key];
            list.push({
                label,
                value: key,
            });
        }
    }
    return list;
}
